var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._t("default", function() {
        return [
          _c("q-btn", {
            attrs: { flat: "", dense: "", round: "", icon: "account_box" },
            on: {
              click: function($event) {
                _vm.isModalOpen = true
              }
            }
          })
        ]
      }),
      _c(
        "q-modal",
        {
          attrs: {
            "content-classes": "q-pa-lg",
            "content-css": "min-width: 70%"
          },
          model: {
            value: _vm.isModalOpen,
            callback: function($$v) {
              _vm.isModalOpen = $$v
            },
            expression: "isModalOpen"
          }
        },
        [
          _c("div", { staticClass: "row q-pb-md" }, [
            _c("div", { staticClass: "col-10" }, [
              _c("span", { staticClass: "text-primary q-title" }, [
                _vm._v("Account Info")
              ])
            ]),
            _c("div", { staticClass: "col-2 text-right" })
          ]),
          _vm.isModalOpen
            ? _c(
                "form",
                {
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.submit.apply(null, arguments)
                    }
                  }
                },
                [
                  _c("user-edit", {
                    attrs: { "account-modal": true, user: _vm.user }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "q-pt-lg q-pb-lg row gutter-xl items-end" },
            [
              _c(
                "div",
                { staticClass: "col-4 text-right" },
                [
                  _c("q-btn", {
                    staticClass: "no-shadow block",
                    attrs: {
                      color: "warning",
                      type: "button",
                      label: "Cancel / Close",
                      flat: ""
                    },
                    on: { click: _vm.handleCancel }
                  })
                ],
                1
              )
            ]
          )
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }